import { useMedplumContext } from '@medplum/react'
import { useQuery } from 'react-query'
import { useUserInfo } from 'src/hooks'

export function useMWLSubscriptionChargeItem() {
    const { medplum } = useMedplumContext()
    const { user } = useUserInfo()

    const query = useQuery(
        ['mwl-subscription-charge-item', user?.id],
        async () => {
            if (!user?.id) {
                return null
            }

            const response = await medplum.searchOne('ChargeItem', {
                'subject:Patient.identifier': user.id,
                'code': 'MWL-SUBSCRIPTION'
            })

            return response
        }
    )

    return {
        isLoading: query.isLoading,
        chargeItem: query.data,
        error: query.error
    }
}
